module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updatePartner($event)
      }
    }
  }, [(_vm.errorMessage) ? _c('Message', {
    attrs: {
      "message-content": _vm.errorMessage,
      "message-status": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Partner name:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partner.name),
      expression: "partner.name"
    }],
    attrs: {
      "name": "",
      "placeholder": "Write a name",
      "required": "",
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.partner.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partner, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Percentage of revenue shared:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "revenueShare"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partner.revenueShare),
      expression: "partner.revenueShare"
    }],
    attrs: {
      "name": "",
      "required": "",
      "placeholder": "Define a percentage of revenue for each video of this partner",
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.partner.revenueShare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partner, "revenueShare", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Stripe Account:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "emailAddress"
    }
  }, [(_vm.stripeShowStatus) ? _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.stripeStatus))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stripeEmailTextField),
      expression: "stripeEmailTextField"
    }],
    attrs: {
      "name": "",
      "required": "",
      "placeholder": _vm.stripeTextFieldPlaceholder,
      "type": "email",
      "value": "",
      "disabled": _vm.stripeShowUnlink
    },
    domProps: {
      "value": (_vm.stripeEmailTextField)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stripeEmailTextField = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.stripeShowInvite) ? _c('button', {
    staticClass: "btn btn_green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.inviteStripeAccount()
      }
    }
  }, [_vm._v("\n                    INVITE\n                ")]) : _vm._e(), _vm._v(" "), (_vm.stripeShowUnlink) ? _c('button', {
    staticClass: "btn btn_red",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.unlinkStripeAccount()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.unlinkTitle) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Delete partner:\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn_red btn_half u-fleft",
    on: {
      "click": function($event) {
        _vm.confirmToggle()
      }
    }
  }, [_vm._v("\n                Delete\n            ")])])], 1), _vm._v(" "), _c('confirm', {
    attrs: {
      "resource": "partner",
      "visible": _vm.alertVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.alertVisible = $event
      }
    }
  }), _vm._v(" "), _c('ok', {
    attrs: {
      "resource": "partner",
      "resource-plural": "partners",
      "visible": _vm.okVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.okVisible = $event
      }
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("\n            Edit Partner Profile\n         ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn_green btn_half u-fleft u-mr1",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    Update\n                ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5d34fb8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5d34fb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partners/EditPartners.vue
// module id = 457
// module chunks = 1